import React from 'react'
import Button from './Button';
import RadioButton from './Radio';

export default ({ data=[], values, onChangeEvent, onSubmit, onError }) => {

  const {
    step,
    errors,
    location,
    address_2,
    email_address,
    delivery_method
  } = values;

  const onSelectDelivery = (e) => {

    onError({});

    const { name } = e.target;

    const selected = data.filter(a => a.name===name) || [];

    return onChangeEvent(selected[0] || {});

  }

  const submit_data = () => {

    const { name } = delivery_method;

    return (!!name) ? onSubmit() : onError({ delivery: 'Select' });

  }

  return (step===2) && (
    <div className='Shipping-Information'>

      <div className="Previous-Data">

        <div className="Data-Row">
          <div className="label">Contact</div>
          <div className="value">{email_address}</div>
        </div>

        <div className="Data-Row">
          <div className="label">Address</div>
          <div className="value">
            {`${address_2}, ${location}`}
          </div>
        </div>

      </div>

      <div className={`Section-Title ${(errors['delivery']) ? 'error' : ''}`}>
        {errors['delivery']} Shipping Method
      </div>

      { data.map(method =>
          <RadioButton
            key={method.name}
            name={method.name}
            onSelect={onSelectDelivery}
            value={method.name === delivery_method.name}
            caption={`
              <span>${method.caption}</span>
              <b>${method.charge} Ksh</b>
            `}
          />
        )
      }

      <Button
        label='Continue to Payment'
        onClickEvent={() => submit_data()}
        onClickBackButton={() => onSubmit(false)}
        backButtonLabel='Contact Information'
      />

    </div>
  )
}
